import { render, staticRenderFns } from "./ChatDetailReason.vue?vue&type=template&id=6afb7402&scoped=true"
import script from "./ChatDetailReason.vue?vue&type=script&lang=js"
export * from "./ChatDetailReason.vue?vue&type=script&lang=js"
import style0 from "./ChatDetailReason.vue?vue&type=style&index=0&id=6afb7402&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6afb7402",
  null
  
)

export default component.exports